import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollToPlugin);
gsap.registerPlugin(ScrollTrigger);

export const animation = () => {
  document.addEventListener("DOMContentLoaded", () => {
    // フェードインアニメーション
    const fadeInElements = document.querySelectorAll(".js-fade-in");
    fadeInElements.forEach((element) => {
      gsap.fromTo(
        element,
        { autoAlpha: 0, y: 30 },
        {
          autoAlpha: 1,
          y: 0,
          duration: 1,
          ease: "power4.out",
          scrollTrigger: {
            trigger: element, // トリガーとなる要素を指定
            start: "top 70%", // スクロール開始位置を指定
            //markers: true,
          },
        }
      );
    });

    const fadeInLeftElements = document.querySelectorAll(".js-fade-in-left");
    fadeInLeftElements.forEach((element) => {
      gsap.fromTo(
        element,
        { autoAlpha: 0, x: -30 },
        {
          autoAlpha: 1,
          x: 0,
          duration: 1,
          ease: "power4.out",
          scrollTrigger: {
            trigger: element, // トリガーとなる要素を指定
            start: "top 70%", // スクロール開始位置を指定
            //markers: true,
          },
        }
      );
    });

    const fadeInRightElements = document.querySelectorAll(".js-fade-in-right");
    fadeInRightElements.forEach((element) => {
      gsap.fromTo(
        element,
        { autoAlpha: 0, x: 30 },
        {
          autoAlpha: 1,
          x: 0,
          duration: 1,
          ease: "power4.out",
          scrollTrigger: {
            trigger: element, // トリガーとなる要素を指定
            start: "top 70%", // スクロール開始位置を指定
            //markers: true,
          },
        }
      );
    });

    // フェードインアニメーション(少し時間差あり)
    const fadeInStaggers = document.querySelectorAll(".js-fade-in-staggers");
    const mm = gsap.matchMedia();
    // 768px以上の時
    mm.add("(min-width:768px)", () => {
      fadeInStaggers.forEach((element) => {
        let stagger = element.querySelectorAll(".js-fade-in-stagger");
        gsap.fromTo(
          stagger,
          { autoAlpha: 0, y: 50 },
          {
            autoAlpha: 1,
            y: 0,
            duration: 1,
            ease: "power4.out",
            stagger: 0.1,
            scrollTrigger: {
              trigger: element, // トリガーとなる要素を指定
              start: "top 70%", // スクロール開始位置を指定
            },
          }
        );
      });
    });
    // 767px以下の時
    mm.add("(max-width:767px)", () => {
      fadeInStaggers.forEach((element) => {
        let stagger = element.querySelectorAll(".js-fade-in-stagger");
        stagger.forEach((e) => {
          gsap.fromTo(
            e,
            { autoAlpha: 0, y: 50 },
            {
              autoAlpha: 1,
              y: 0,
              duration: 1,
              ease: "power4.out",
              scrollTrigger: {
                trigger: e, // トリガーとなる要素を指定
                start: "top 70%", // スクロール開始位置を指定
              },
            }
          );
        });
      });
    });

    // スクロールによる強調アニメーション
    const enphasisTargetElement = document.querySelectorAll(".p-support__item");
    enphasisTargetElement.forEach((element) => {
      gsap.to(element, {
        scrollTrigger: {
          trigger: element, // トリガーとなる要素を指定
          start: "top 50%", // スクロール開始位置を指定
          end: "bottom 50%", // スクロール終了位置を指定
          toggleActions: "play none none reverse", // 上スクロールで戻る
          toggleClass: {
            // クラス名の付替え
            targets: element,
            className: "is-active",
          },
        },
      });
    });
    // スクロールによる強調アニメーション
    const pieChart = document.querySelector(".pie-chart-inner");
    gsap.fromTo(
      pieChart,
      { "stroke-dasharray": "753.6 753.6" },
      {
        "stroke-dasharray": "4 753.6",
        duration: 2,
        ease: "power4.out",
        scrollTrigger: {
          trigger: pieChart, // トリガーとなる要素を指定
          start: "top 70%", // スクロール開始位置を指定
        },
      }
    );
  });
  // スクロール位置
  document.addEventListener("DOMContentLoaded", () => {
    const links = {
      step: document.querySelector("#stepLink"),
      features: document.querySelector("#featuresLink"),
      reason: document.querySelector("#reasonLink"),
      worried: document.querySelector("#worriedLink"),
      cta: document.querySelector("#ctaLink"),
      works: document.querySelector("#worksLink"),
      support: document.querySelector("#supportLink"),
      qa: document.querySelector("#qaLink"),
    };
    // 初期状態で#saleリンクにis-activeクラスを追加
    if (links.step) {
      links.step.classList.add("is-active");
    }
  });

  document.addEventListener("scroll", () => {
    const targets = document.querySelectorAll(".js-target");
    const scrollPosition = window.scrollY + window.innerHeight / 4;

    const links = {
      step: document.querySelector("#stepLink"),
      features: document.querySelector("#featuresLink"),
      reason: document.querySelector("#reasonLink"),
      worried: document.querySelector("#worriedLink"),
      cta: document.querySelector("#ctaLink"),
      works: document.querySelector("#worksLink"),
      support: document.querySelector("#supportLink"),
      qa: document.querySelector("#qaLink"),
    };

    targets.forEach((target) => {
      const targetTop = target.offsetTop;
      const targetHeight = target.offsetHeight;

      if (scrollPosition >= targetTop && scrollPosition < targetTop + targetHeight) {
        // すべてのリンクのクラスをリセット
        Object.values(links).forEach((link) => {
          if (link.classList.contains("is-active")) {
            link.classList.remove("is-active");
          }
        });

        // 現在のセクションに対応するリンクのスタイルを変更
        if (links[target.id]) {
          links[target.id].classList.add("is-active");
        }
      }
    });
  });
};
